import { CircularProgress, Box, Typography, Fade } from "@mui/material";
import { flexCenter } from "../theme/responsive";

/**
 * Enhanced Loader component with optional message and sizing
 * @param {string} message - Optional loading message
 * @param {string} size - Size of loader (small, medium, large)
 * @param {string} minHeight - Minimum height of container
 * @param {boolean} fullScreen - Whether to fill entire screen
 */
export default function Loader({
  message,
  size = "medium",
  minHeight = "50vh",
  fullScreen = false,
}) {
  const sizeMap = {
    small: 24,
    medium: 40,
    large: 60,
  };

  return (
    <Fade in timeout={300}>
      <Box
        sx={{
          ...flexCenter,
          flexDirection: "column",
          gap: 2,
          minHeight: fullScreen ? "100vh" : minHeight,
          width: "100%",
        }}
      >
        <CircularProgress size={sizeMap[size]} thickness={4} />
        {message && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 1, textAlign: "center" }}
          >
            {message}
          </Typography>
        )}
      </Box>
    </Fade>
  );
}
